module.exports = __webpack_public_path__ + "dd2fe8fab224ae6d05efecb715a940e7.pdf";